"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contract = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const TermsAcceptance_1 = require("./TermsAcceptance");

const types_1 = require("./types");

class Contract {
  /**
   * @description Creates a new Contract for use.
   *
   * @param {Object} options Initialization Object (params described below)
   *
   * @param {String} options.id Contract's ID
   * @param {String} options.buyingProgram Contract's buying program
   * @param {String} options.model Returned if using the Contract Service
   * @param {String} options.orgId Contract's OrgId
   * @param {String} options.orgName Contract's orgName
   * @param {String} options.routeToMarket Contract's route to market.
   *   Possible values are: ENTERPRISE, INDIRECT, or DIRECT (previously
   *   known as ContractType)
   * @param {String} options.status Contract's status. ACTIVE, INACTIVE or EXPIRED (introduced for trials).
   * @param {CustomerSegment} options.customerSegment The contract's customer segment
   * @param {SalesChannel} options.salesChannel A Contract's sales channel. Available when temp_use_clam is removed.
   * @param {TermsAcceptance} options.termsAcceptances List of term acceptance information
   */
  constructor(options) {
    const {
      termsAcceptances
    } = options,
          otherOptions = __rest(options, ["termsAcceptances"]);

    Object.assign(this, otherOptions);
    this.termsAcceptances = termsAcceptances === null || termsAcceptances === void 0 ? void 0 : termsAcceptances.map(termAcceptance => new TermsAcceptance_1.TermsAcceptance(termAcceptance));
  }
  /**
   * @description Returns true if this is an allocation contract.
   *
   * @returns {Boolean} true if this is an allocation contract.
   */


  isModelAllocation() {
    return this.model === types_1.CONTRACT_MODEL.ALLOCATION;
  }

  isBuyingProgramETLA() {
    return this.buyingProgram === types_1.CONTRACT_BUYING_PROGRAM.ETLA;
  }
  /**
   * @description Returns true if this is an enterprise contract in the DIRECT channel.
   *
   * @returns {Boolean} true if this is an enterprise contract in the DIRECT channel.
   */


  isEnterpriseContract() {
    return this.customerSegment === types_1.CustomerSegment.ENTERPRISE && this.isSalesChannelDirect();
  }
  /**
   * @description Returns true if this is an indirect contract.
   *
   * @returns {Boolean} true if this is an indirect contract.
   */


  isIndirectContract() {
    return this.salesChannel === types_1.SalesChannel.INDIRECT;
  }
  /**
   * @description Returns true if this is a Contract Service trial contract. JEM does not use this property.
   *
   * @returns {Boolean} true if this is a trial contract
   */


  isModelTrial() {
    return this.model === types_1.CONTRACT_MODEL.TRIAL;
  }
  /**
   * @description Returns true if this is a trial contract.
   *  Legacy ETLA trial contracts (model='TRIAL' and an ETLA buying program) should be treated as ETLA
   *  contracts and are not considered true trial contracts.
   *
   * @returns {Boolean} true if this should be treated as a trial contract
   */


  isTrial() {
    return this.isModelTrial() && !this.isBuyingProgramETLA();
  }
  /**
   * @description Returns true of salesChannel is DIRECT
   * @returns {Boolean} true if this contract's salesChannel is DIRECT
   */


  isSalesChannelDirect() {
    return this.salesChannel === types_1.SalesChannel.DIRECT;
  }
  /**
   * @description Method to determine if a contract's customer segment or sales channel
   * is valid
   * @returns {Boolean} true if route to market value is valid, else false
   */


  isValidSalesChannelOrCustomerSegment() {
    return !!this.salesChannel && types_1.SalesChannel[this.salesChannel] !== undefined || !!this.customerSegment && types_1.CustomerSegment[this.customerSegment] !== undefined;
  }

}

exports.Contract = Contract;